import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'usimweb-paginator',
    template: ` <mat-paginator (page)="onPaginateChange($event)" [pageSizeOptions]="pageSizeOptions" [length]="length" showFirstLastButtons></mat-paginator> `,
    standalone: false
})
export class PaginatorComponent {
  @Input() pageSizeOptions: number[] = [10, 20, 50];
  @Input() length!: number;
  @Output() changedPage: EventEmitter<PageEvent> = new EventEmitter();

  public onPaginateChange(event: PageEvent) {
    this.changedPage.emit(event);
  }
}
